import React, { useContext } from 'react';
import HmiContext from '../../context/HmiContext';
import FormatMessage from '../../messages/FormatMessage';
import unbundle from '../../utils/unbundle';
import HmiCard from './HmiCard';

const HmiDataDebit: React.FC = () => {
  const hmiContext = useContext(HmiContext);
  const { parentApp } = hmiContext.hmi;

  if (!parentApp) {
    return null;
  }

  const { permissions } = parentApp;

  if (permissions.dataRetrieved && permissions.dataRetrieved.bundle) {
    const bundle = unbundle(permissions.dataRetrieved.bundle);

    return (
      <div className={'hmi-data-debit'}>
        <HmiCard
          titleMessageId={'hmi.dataDebit.useYourData'}
          expansionPanel={true}
        >
          <div className={'hmi-card-subtitle hmi-card-content'}>
            <FormatMessage
              id={'hmi.dataDebit.appAbleToUse'}
              values={{ name: parentApp.info.name }}
            />
            <br />
            <br />

            {bundle.map(value => {
              return (
                <div
                  className={'hmi-data-debit-list-wrapper'}
                  key={value.title}
                >
                  <div>{value.title} data</div>
                  <ul className={'hmi-data-debit-list'}>
                    {value.fields.map(field => {
                      return <li key={field}>{field}</li>;
                    })}
                  </ul>
                </div>
              );
            })}
          </div>
        </HmiCard>
      </div>
    );
  } else {
    return null;
  }
};

export default HmiDataDebit;
